/**
 * Magicstar Theme — Core JS
 * Handles: header mobile menu, search overlay, cart count sync
 */

(function () {
  'use strict';

  // ── Mobile Menu ──────────────────────────────────────────────────────────

  var menuToggle = document.querySelector('.site-header__menu-toggle');
  var menuDrawer = document.getElementById('mobile-menu-drawer');
  var menuCloseButtons = document.querySelectorAll('.js-menu-close');

  if (menuToggle && menuDrawer) {
    menuToggle.addEventListener('click', function () {
      var isOpen = menuDrawer.classList.contains('is-open');
      menuDrawer.classList.toggle('is-open', !isOpen);
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      menuDrawer.setAttribute('aria-hidden', String(isOpen));
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });

    menuCloseButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        menuDrawer.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menuDrawer.classList.contains('is-open')) {
        menuDrawer.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        menuToggle.focus();
      }
    });
  }

  // ── Search Overlay ───────────────────────────────────────────────────────

  var searchOverlay = document.getElementById('search-overlay');
  var searchInput = document.getElementById('search-input');
  var searchToggleButtons = document.querySelectorAll('.js-search-toggle');
  var searchCloseButtons = document.querySelectorAll('.js-search-close');
  var searchResults = document.getElementById('search-results');
  var searchDebounce;

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      if (searchInput) searchInput.focus();
    }, 200);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
  }

  searchToggleButtons.forEach(function (btn) {
    btn.addEventListener('click', openSearch);
  });

  searchCloseButtons.forEach(function (btn) {
    btn.addEventListener('click', closeSearch);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) {
      closeSearch();
    }
  });

  // Predictive search
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounce);
      var term = searchInput.value.trim();
      if (term.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchDebounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data.resources && data.resources.results && data.resources.results.products;
            if (!products || !products.length) {
              searchResults.innerHTML = '<p style="padding:16px 20px;color:#888;font-size:14px;">No results found.</p>';
              return;
            }
            var html = products.map(function (p) {
              // featured_image is an object {url, alt} in Shopify's suggest API
              var imgSrc = p.featured_image
                ? (p.featured_image.url || (typeof p.featured_image === 'string' ? p.featured_image : null))
                : null;
              // Add ?width=96 for a fast thumbnail; strip any existing query params first
              if (imgSrc) {
                imgSrc = imgSrc.split('?')[0] + '?width=96';
              }
              // price_min is a decimal string like "769.00" — format as "AED 769"
              var rawPrice = p.price_min || p.price || '';
              var priceFormatted = rawPrice
                ? 'AED\u00a0' + Math.round(parseFloat(rawPrice)).toLocaleString()
                : '';
              return '<a href="' + escapeHtml(p.url || '') + '" class="search-result-item">' +
                (imgSrc ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy" width="48" height="48">' : '<span class="search-result-img-placeholder"></span>') +
                '<div><span class="search-result-title">' + escapeHtml(p.title || '') + '</span>' +
                '<span class="search-result-price">' + escapeHtml(priceFormatted) + '</span></div>' +
                '</a>';
            }).join('');
            searchResults.innerHTML = html;
          })
          .catch(function () {
            searchResults.innerHTML = '';
          });
      }, 280);
    });
  }

  // ── Toast Notification ───────────────────────────────────────────────────

  window.showCartToast = function (message) {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    toast.textContent = message || 'Added to cart!';
    toast.removeAttribute('hidden');
    toast.classList.add('is-visible');
    clearTimeout(window.__toastTimer);
    window.__toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.setAttribute('hidden', ''); }, 300);
    }, 2500);
  };

  // ── Update Cart Count (all places in the DOM) ────────────────────────────

  window.updateCartCount = function (count) {
    var countEls = document.querySelectorAll('.cart-count');
    countEls.forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.classList.remove('is-hidden');
      } else {
        el.classList.add('is-hidden');
      }
    });
    // Also update drawer count badge
    var drawerCount = document.getElementById('drawer-item-count');
    if (drawerCount) drawerCount.textContent = count;
  };

  // ── Back to Top Button ───────────────────────────────────────────────────

  var backToTopBtn = document.getElementById('back-to-top');
  if (backToTopBtn) {
    var scrollThreshold = 400;

    function toggleBackToTop() {
      if (window.scrollY > scrollThreshold) {
        backToTopBtn.removeAttribute('hidden');
        backToTopBtn.classList.add('is-visible');
      } else {
        backToTopBtn.classList.remove('is-visible');
        setTimeout(function () {
          if (!backToTopBtn.classList.contains('is-visible')) {
            backToTopBtn.setAttribute('hidden', '');
          }
        }, 260);
      }
    }

    window.addEventListener('scroll', toggleBackToTop, { passive: true });

    backToTopBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ── Facebook Domain Verification meta tag ───────────────────────────────
  // (Already in settings_schema, but ensure it's injected into <head> if set)
  // This is handled in layout/theme.liquid via content_for_header

})();
